class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.currentCount = "";
      this.getSectionsToRender().forEach((section => {
        var cartCountSec = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        
        if(cartCountSec.includes("cart-count-bubble")){
          var currentCount = cartCountSec.split('<div class="cart-count-bubble"><span aria-hidden="true">');
           currentCount = currentCount[1].split("</span>");
           this.currentCount = currentCount[0];
           document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        } else if(cartCountSec.includes("View my cart")){
          document.getElementById(section.id).innerHTML =
          "View my cart ("+this.currentCount+")";
        }else
        {
          document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        } 
      }));

      //if (this.header) this.header.reveal();
        // Try to find header if not found initially (in case it loads after cart-notification) fix for product-form.js
      if (!this.header) {
        this.header = document.querySelector('sticky-header');
      }
      
      if (this.header && typeof this.header.reveal === 'function') {
        this.header.reveal();
      }
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: '.cart-item',//`[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-icon-bubble'//'cart-notification-button'
      },
      {
        id: 'cart-notification-button'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
